<template>
  <div class="office_area">
    <h5>加算チェック関連項目</h5>
    <div class="input_row">
      <label for="is_shift_system" class="required">労働時間制</label>
      <div>
        <div class="input_row">
          <b-form-select
            v-model="form.is_shift_system" 
            :options="shift_system_options"
            style="min-width: 200px; 
            max-width: 200px;"
            @change="$emit('change')"
          />
        </div>
        <div v-if="errors.is_shift_system" class="invalid-feedback">{{ errors.is_shift_system }}</div>
      </div>
    </div>
    <div class="input_row">
      <label for="workingdays_per_week" >1週当たり勤務日数</label>
      <div>
        <div class="input_row">
          <input
              v-model.number="form.workingdays_per_week"
              type="number"
              class="form-control"
              style="width: 65px; margin-right: 8px;"
              min="0"
              max="7"
              @change="$emit('change')"
            />
          <p class="after_label">日</p>
        </div>
        <div v-if="errors.workingdays_per_week" class="invalid-feedback">{{ errors.workingdays_per_week }}</div>
      </div>
    </div>
    <div class="input_row">
      <label for="workinghours_per_week">1週当たり勤務時間</label>
      <div>
        <div class="input_row">
          <input
              v-model.number="form.workinghours_per_week"
              type="number"
              class="form-control"
              style="width: 65px; margin-right: 8px;"
              min="0"
              max="168"
              @change="$emit('change')"
            />
          <p class="after_label">時間</p>
        </div>
        <div v-if="errors.workinghours_per_week" class="invalid-feedback">{{ errors.workinghours_per_week }}</div>
      </div>
    </div>
    <div class="input_row">
      <label for="workinghours_per_day" class="required">1日当たり勤務時間</label>
      <div>
        <div class="input_row">
          <input
              v-model.number="form.workinghours_per_day"
              type="number"
              class="form-control"
              style="width: 65px; margin-right: 8px;"
              min="0"
              max="24"
              @change="$emit('change')"
            />
          <p class="after_label">時間</p>
        </div>
        <div v-if="errors.workinghours_per_day" class="invalid-feedback">{{ errors.workinghours_per_day }}</div>
      </div>
    </div>
    <div class="input_row">
        <label for="daywork_start_time">利用者の生活時間帯（日中）</label>
        <div>
            <div class="input_row">
                <v-menu
                    ref="menu1"
                    v-model="form.dayworkStartMenu"
                    :close-on-content-click="false"
                    :return-value.sync="form.daywork_start_time"
                    transition="scale-transition"
                    offset-x
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="form.daywork_start_time"
                            background-color="white"
                            hide-details="false"
                            v-on="on"
                            dense
                            outlined
                            placeholder=""
                            style="width: 120px; min-width: 120px; font-size: 1rem;"
                            :class="{ 'is-invalid': errors.daywork_start_time }"
                            @click="setFocuseTime(form.daywork_start_time, 'daywork_start_picker')"
                            @keydown="form.dayworkStartMenu = false"
                            @blur="outFocuseTime(form.daywork_start_time, 'daywork_start_time')"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        ref="daywork_start_picker"
                        v-model="form.daywork_start_time"
                        format="24hr"
                        full-width
                        @click:minute="$refs.menu1.save(form.daywork_start_time)"
                    ></v-time-picker>
                </v-menu>
                <p class="after_label" style="padding: 9px 4px">～</p>
                <v-menu
                    ref="menu3"
                    v-model="form.dayworkEndMenu"
                    :close-on-content-click="false"
                    :return-value.sync="form.daywork_end_time"
                    transition="scale-transition"
                    offset-x
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="form.daywork_end_time"
                            background-color="white"
                            hide-details="false"
                            v-on="on"
                            dense
                            outlined
                            placeholder=""
                            style="width: 120px; min-width: 120px; font-size: 1rem;"
                            :class="{ 'is-invalid': errors.daywork_end_time }"
                            @click="setFocuseTime(form.daywork_end_time, 'daywork_end_picker')"
                            @keydown="form.dayworkEndMenu = false"
                            @blur="outFocuseTime(form.daywork_end_time, 'daywork_end_time')"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        ref="daywork_end_picker"
                        v-model="form.daywork_end_time"
                        format="24hr"
                        full-width
                        @click:minute="$refs.menu3.save(form.daywork_end_time)"
                    ></v-time-picker>
                </v-menu>
            </div>
            <div v-if="errors.daywork_start_time" class="invalid-feedback">
                {{ errors.daywork_start_time }}
            </div>
            <div v-if="errors.daywork_end_time" class="invalid-feedback">
                {{ errors.daywork_end_time }}
            </div>
        </div>
    </div>
    <div class="input_row">
        <label for="daywork_start_time">夜間及び深夜の時間帯</label>
        <div>
            <div class="input_row">
                <input
                    type="text"
                    v-model="form.nightwork_start_time"
                    name="nightwork_start_time"
                    class="form-control"
                    style="width: 120px; min-width: 120px;"
                    readonly
                />
                <p class="after_label" style="padding: 9px 4px">～</p>
                <input
                    type="text"
                    v-model="form.nightwork_end_time"
                    name="nightwork_end_time"
                    class="form-control"
                    style="width: 120px; min-width: 120px;"
                    readonly
                />
            </div>
            <div v-if="errors.nightwork_start_time" class="invalid-feedback">
                {{ errors.nightwork_start_time }}
            </div>
            <div v-if="errors.nightwork_end_time" class="invalid-feedback">
                {{ errors.nightwork_end_time }}
            </div>
        </div>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      shift_system_options: [
        { value: false, text: '変形労働時間制' },
        { value: true, text: 'シフト制' }
      ],
      dayworkStartMenu: false, // 開始時間メニュー開閉状態
      dayworkEndMenu: false,    // 終了時間メニュー開閉状態

      workTimeValidationCheck: true,
    }
  },
  watch: {
        'form.daywork_start_time': function (val) {
            let isError = this.validateWorkTime(val, 'daywork_start_time', 'daywork_end_time');
            this.setNightWorkTime(val, this.form.daywork_end_time, isError);
        },
        'form.daywork_end_time': function (val) {
            let isError = this.validateWorkTime(val, 'daywork_end_time', 'daywork_start_time');
            this.setNightWorkTime(this.form.daywork_start_time, val, isError);
        },
    },
    methods: {
        validateWorkTime(val, thisKey, otherKey) {
            this.workTimeValidationCheck = true;
            this.errors[thisKey] = null;
            this.errors[otherKey] = null;

            let result = this.checkValid(val, thisKey, otherKey);

            if (result.isError) {
                this.workTimeValidationCheck = false;
                this.errors[thisKey] = result.errorMessage;
            }
            return result.isError;
        },

        checkValid(val, thisKey, otherKey) {
            let result = { isError: false, errorMessage: '' };
            let labels = {
                daywork_start_time: '開始',
                daywork_end_time: '終了',
            };

            if (!this.hasValue(val) && this.hasValue(this.form[otherKey])) {
                result.isError = true;
                result.errorMessage = `${labels[thisKey]}時間を入力してください。`;
                return result;
            }

            if (this.hasValue(val) && !this.hasValue(this.form[otherKey])) {
                result.isError = true;
                result.errorMessage = `${labels[otherKey]}時間を入力してください。`;
                return result;
            }

            if (this.hasValue(val) && this.hasValue(this.form[otherKey])) {
                let startTime = labels[thisKey] === '開始' ? val : this.form[otherKey];
                let endTime = labels[thisKey] === '終了' ? val : this.form[otherKey];
                if (!this.isStartTimeBeforeEndTime(startTime, endTime)) {
                    result.isError = true;
                    result.errorMessage = '開始時間 < 終了時間となるように入力してください。';
                    return result;
                }
            }

            return result;
        },

        setNightWorkTime(startTime, endTime, isError) {
            if (
                !isError
                && startTime
                && endTime
            ) {
                this.form.nightwork_start_time = endTime;
                this.form.nightwork_end_time = startTime;
            } else {
                this.form.nightwork_start_time = '';
                this.form.nightwork_end_time = '';
            }
        },

        workConditionValidation() {
            return this.workTimeValidationCheck;
        },

        setFocuseTime(value, pickerKey) {
            if (!this.hasValue(value) && this.$refs[pickerKey]) {
                this.$refs[pickerKey].selectingHour = true;
            }
        },

        outFocuseTime(value, fieldKey) {
            if (this.hasValue(value) && !this.isTimeFormat(value)) {
                this.form[fieldKey] = null;
            }
        },

        isTimeFormat(str) {
            return /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(str);
        },

        hasValue(value) {
            return value !== null && value !== '' && value !== undefined;
        },

        isStartTimeBeforeEndTime(startTime, endTime) {
            const regex = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
            const startMatch = startTime.match(regex);
            const endMatch = endTime.match(regex);

            if (!startMatch || !endMatch) return false;

            // 分に換算
            const startMinutes = parseInt(startMatch[1]) * 60 + parseInt(startMatch[2]);
            const endMinutes = parseInt(endMatch[1]) * 60 + parseInt(endMatch[2]);
            return startMinutes < endMinutes;
        },
    }
}
</script>
